import Vue from "vue";
import VueRouter from "vue-router";

// 解决两次访问相同路由地址报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

/* layout */
import Layout from '../layout/index'

const baseRoutes = [
	{
		path: '/',
		name: '/',
		redirect: '/login',
	},
	{
		path: '/login',
		name: 'login',
		meta: {
			title: '登录',
		},
		component: () => import('../views/login/index.vue'),
	},
	{
		path: '/404',
		name: '404',
		meta: {
			title: '404',
		},
		component: () => import('../views/error-page/404.vue'),
	},
	{
		path: '/redirect',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/redirect/:path*',
				component: () => import('../views/redirect/index')
			}
		]
	},
	{
		path: '/projectAnalysis',
		name: 'ProjectAnalysis11',
		meta: {
			title: '造价分析',
		},
		component: () => import('../views/project-management/project-info/tabs_index.vue'),
	},
    {
        path: '/projectAnalysis/estimate-price',
        name: 'EstimatePrice1',
        meta: {
            title: '概算价',
        },
        component: () => import('../views/project-management/estimate-price/index.vue'),
    }
]

const mainRoutes = []

const routes = [...baseRoutes, ...mainRoutes]

const router = new VueRouter({
	routes
});

export default router;